import { render } from "./CreateAccount.vue?vue&type=template&id=72b04d82&scoped=true"
import script from "./CreateAccount.vue?vue&type=script&lang=ts"
export * from "./CreateAccount.vue?vue&type=script&lang=ts"

import "./CreateAccount.vue?vue&type=style&index=0&id=72b04d82&lang=scss"
import "./CreateAccount.vue?vue&type=style&index=1&id=72b04d82&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-72b04d82"

export default script